import React from 'react';
import { Sunrise } from 'lucide-react';
import { MorningBootWizard, useMorningBoot } from '@priorities-ai/morning-boot';
import { createElevationAdapter, ELEVATION_BOOT_STORAGE_KEY } from './adapters/elevation';

export const MorningBootExperience: React.FC = () => {
  const boot = useMorningBoot({
    storageKey: ELEVATION_BOOT_STORAGE_KEY,
    adapter: createElevationAdapter(),
  });

  return (
    <MorningBootWizard
      boot={boot}
      theme="elevation"
      title="Morning Boot Routine"
      subtitle="Start your day with three clear priorities before email and calendar take over."
      dashboardPath="/home"
    />
  );
};

export const MorningBootLab: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="text-center space-y-2">
        <div className="flex items-center justify-center gap-3">
          <Sunrise className="h-8 w-8 text-primary-600" />
          <h1 className="text-3xl font-bold text-charcoal-900">Morning Boot Routine (Lab)</h1>
        </div>
        <p className="text-charcoal-600 text-sm">
          Solo daily prioritization from Managing Priorities — purge, tag, rank, timebox, focus.
        </p>
      </div>
      <MorningBootExperience />
    </div>
  );
};
